import { StyleSheet } from '@react-pdf/renderer'
import { theme } from '../../theme/theme'

export const styles = StyleSheet.create({
  /* PAGE */
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    height: '100%',
    position: 'absolute',
  },
  pageContainerInner: {
    paddingHorizontal: 30,
  },

  /* CONTAINERS */
  logoContainer: {
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  headerContainer: {
    borderTopWidth: 5,
    borderTopColor: theme.colors.purple[400],
    padding: 30,
  },
  footerContainer: {
    backgroundColor: theme.colors.purple[400],
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 15,
  },
  logoSection: {
    width: 40,
    alignItems: 'flex-start',
    marginRight: 10,
  },
  companySection: {
    width: 120,
    alignItems: 'flex-start',
  },
  contactSection: {
    flex: 1,
    alignItems: 'flex-end',
  },
  flexRowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  flexColContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  mYcontainer: {
    marginVertical: 10,
  },
  mYmediumContainer: {
    marginVertical: 5,
  },
  cardContainer: {
    padding: 10,
    borderRadius: 5,
    backgroundColor: theme.colors.brand.extraLightGrayBg,
  },

  /* IMAGES */
  logo: {
    width: 30,
  },

  /* TEXT */
  title: {
    fontSize: 16,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.colors.brand.darkGray,
  },
  subTitle: {
    fontSize: 12,
    color: theme.colors.brand.lightGrayText,
    marginTop: 5,
  },
  grayText: {
    fontSize: 10,
    color: theme.colors.brand.lightGrayText,
  },
  text: {
    fontSize: 10,
    color: theme.colors.brand.darkGray,
  },
  footerText: {
    color: 'white',
    fontSize: 10,
  },
  footerCompagnyText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
  footerInfo: {
    fontSize: 8,
    color: 'white',
    textAlign: 'right',
  },
  boldText: {
    fontWeight: 'bold',
  },

  /* DIVIDERS */
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.brand.lightGrayBorder,
    marginTop: 4,
    marginBottom: 10,
    width: '100%',
  },

  /* TABLE */
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#dddddd',
    borderBottomStyle: 'solid',
    minHeight: 24,
    fontSize: 9,
  },
  tableCell: {
    flex: 1,
    padding: 5,
  },
  headerCell: {
    fontWeight: 'bold',
  },
  sectionContainer: {
    marginVertical: 10,
  },
  sectionHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  partyContainer: {
    flex: 1,
  },
  labelText: {
    fontSize: 10,
    color: theme.colors.brand.lightGrayText,
    marginRight: 5,
    flex: 0.4,
  },
  valueText: {
    fontSize: 10,
    color: theme.colors.brand.darkGray,
    flex: 0.6,
  },
  table: {
    width: '100%',
    marginTop: 10,
  },
  headerRow: {
    backgroundColor: theme.colors.purple[100],
  },
  amountCell: {
    textAlign: 'right',
  },
  totalRow: {
    backgroundColor: theme.colors.brand.extraLightGrayBg,
    borderTopWidth: 1,
    borderTopColor: theme.colors.brand.lightGrayBorder,
    marginTop: 5,
  },
})
